import type { AmbassadorResponse } from '../../api/earnings/ambassador'

type Props = {
  rows: AmbassadorResponse['recent_activity']
}

export default function AmbassadorActivityList({ rows }: Props) {
  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">Recent Earnings Activity</h2>
      {rows.length === 0 ? (
        <div className="mt-3 rounded-xl border border-white/10 bg-black/30 p-4 text-sm text-white/65">
          No earnings activity yet.
        </div>
      ) : (
        <div className="mt-3 overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="text-left text-white/60">
              <tr>
                <th className="py-2 pr-4">Date</th>
                <th className="py-2 pr-4">Type</th>
                <th className="py-2 pr-4">Amount (PIXE)</th>
                <th className="py-2 pr-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="border-t border-white/10">
                  <td className="py-2 pr-4 text-white/80">{new Date(row.created_at).toLocaleDateString()}</td>
                  <td className="py-2 pr-4 text-white/80">{row.note || 'Referral fee'}</td>
                  <td className="py-2 pr-4 font-semibold text-cyan-100">{row.amount}</td>
                  <td className="py-2 pr-4">
                    <span className={`rounded-full px-2 py-0.5 text-xs ${row.status === 'settled' ? 'bg-emerald-500/15 text-emerald-200' : 'bg-white/10 text-white/75'}`}>
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
